<div class="grid dashboard-grid flex-1">
  <div class="flex gap-2 column">
    <app-system-stop
      type="dashboard"
      [isEmegancyStopActive$]="isEmegancyStopActive$"
      [isSystemRunning$]="isSystemRunning$"
      (triggerKillSwitch)="onTriggerKillSwitch($event)"
    />

    <app-notifications-dashboard-card class="flex flex-1" />

    <app-weather-dashboard-card />

    <!--    <app-camera-dashboard-card class="flex flex-1"/>-->
  </div>

  <div class="flex column">
    <app-devices-dashboard-card
      [isSystemRunning]="!!(isSystemRunning$ | async)"
      (triggerDeviceAction)="onTriggerDeviceAction($event)"
      (triggerDeviceGroupAction)="onTriggerDeviceGroupAction($event)"
      [devices$]="favoriteDevices$"
      [deviceGroups$]="favoriteDeviceGroups$"
      class="flex flex-1"
    />
  </div>

  <div class="flex column">
    <div class="flex column gap-1 flex-1">
      @let cisternList = (cisternList$ | async) ?? [];

      @for (cistern of cisternList.slice(0, 2); track cistern.id) {
        <app-cistern-item-card
          [cistern]="cistern"
          [navigateToStatistics]="true"
          class="flex flex-1"
        />
      }

      @if (cisternList.length > 2) {
        <a
          class="button icon-button end"
          [routerLink]="['/', RouteConstants.routeCistern]"
        >
          {{ "cisterns.detail.error.goTo" | translate }}
          <app-icon name="ic_chevron_right" />
        </a>
      }
    </div>
    <app-device-values-dashboard-card
      [soilDeviceList$]="soilDeviceList$"
      [flowDeviceList$]="flowDeviceList$"
    />

    <!--    todo include in another release-->
    <!--    <app-card class="flex-none smart-mode" [class.active]="isSmartModeRunning">-->
    <!--      <div class="header">-->
    <!--        <p class="uppercase">{{ 'dashboard.smartMode.label' | translate }}</p>-->
    <!--        <mat-slide-toggle [(ngModel)]="isSmartModeRunning"/>-->
    <!--      </div>-->
    <!--    </app-card>-->
  </div>
</div>
<!--<div class="flex">-->
<!--  <app-card>-->
<!--    timeline-->
<!--  </app-card>-->
<!--  <app-statistics-dashboard-card/>-->
<!--</div>-->
